import Axios from "axios";
import {
    SET_LEAVE_EARNED_REGISTER_REPORT_LIST, 
    UNSET_LEAVE_EARNED_REGISTER_REPORT_LIST
} from "@/store/mutation-types";
import {
    getLeaveEarnedRegisterReport,
} from "@/store/api";

const state = {
    getLeaveEarnedRegisterReport: [],
};

const getters = {
    getLeaveEarnedRegisterReport(state) {
        return state.getLeaveEarnedRegisterReport;
    },
};

const mutations = {
    [SET_LEAVE_EARNED_REGISTER_REPORT_LIST](state, data) {
        state.getLeaveEarnedRegisterReport = data;
    },
    [UNSET_LEAVE_EARNED_REGISTER_REPORT_LIST](state) {
        state.getLeaveEarnedRegisterReport = [];
    },
};

const actions = {

    getLeaveEarnedRegisterReport({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${getLeaveEarnedRegisterReport}`, { params: data })
                .then((response) => {
                    commit(SET_LEAVE_EARNED_REGISTER_REPORT_LIST, response.data.data );
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_LEAVE_EARNED_REGISTER_REPORT_LIST);
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
    

};


export default {
    state,
    getters,
    actions,
    mutations,
};